var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4719 24.4554L11.4729 24.4543C12.65 22.9811 14.5867 20.4524 16.2316 17.7841C17.0539 16.4501 17.8093 15.0717 18.3605 13.7661C18.9082 12.4687 19.2718 11.2031 19.2718 10.1063C19.2718 4.98523 15.1186 0.833984 9.99941 0.833984C4.87837 0.833984 0.727051 4.9853 0.727051 10.1063C0.727051 11.2024 1.0876 12.4675 1.6321 13.7651C2.18002 15.0708 2.93154 16.4493 3.75145 17.7835C5.39108 20.4517 7.32773 22.9805 8.52788 24.4566C9.29025 25.4034 10.7101 25.403 11.4719 24.4554ZM12.4235 10.1063C12.4235 11.443 11.3361 12.5305 9.99941 12.5305C8.66272 12.5305 7.57529 11.443 7.57529 10.1063C7.57529 8.76965 8.66272 7.68223 9.99941 7.68223C11.3361 7.68223 12.4235 8.76965 12.4235 10.1063Z",
    fill: "#5AB026",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinGreen);
export default __webpack_public_path__ + "static/media/pin_green.cd721052.svg";
export { ForwardRef as ReactComponent };